module.exports = __webpack_public_path__ + "img/xiaoyuan.67249b69.jpg";